<div class="densest">
  <div>
    <label [for]="id" class="datepicker-label"
      >{{ label }}<span *ngIf="required"> *</span></label
    >
  </div>
  <mat-form-field appearance="outline" class="datepicker-form-field">
    <input
      (click)="!isReadOnly && clearInput()"
      [formControl]="control"
      [id]="id"
      [matDatepicker]="picker"
      [placeholder]="placeholder"
      [readonly]="isReadOnly"
      [attr.aria-readonly]="isReadOnly ? 'true' : null"
      matInput
    />
    <mat-icon
      *ngIf="control.status == 'INVALID' && control.touched"
      class="datepicker-icon"
      matSuffix
      >error_outline
    </mat-icon>
    <mat-datepicker-toggle
      [for]="picker"
      [disabled]="isReadOnly"
      matIconSuffix
      matSuffix
    />
    <mat-datepicker #picker matSuffix />
    <mat-error class="datepicker-error">{{ errorText }}</mat-error>
  </mat-form-field>
</div>
